import { useState } from "react";

import { useProfileData } from "@/hooks/use-profile-data";

import { koryRankedFeedOverride } from "./flag";

/**
 * Overview's gate for the feed, shared by Overview and the surfaces around it (the tray's focus
 * mode, the page lens, the styleguide): this browser's `kory_ranked_feed` override (read once per
 * mount) or, with none set, the person's admin-set New Overview switch. Assistant mode plays no part.
 */
export function useRankedFeedGate(): boolean {
  return useRankedFeedGateStatus().on;
}

/** The gate, and whether it is still waiting on the profile (so a page can hold its layout until it knows). */
export function useRankedFeedGateStatus(): { on: boolean; pending: boolean } {
  const [override] = useState(koryRankedFeedOverride);
  const profile = useProfileData();
  if (override !== null) return { on: override, pending: false };
  return { on: profile.data?.new_overview === true, pending: profile.isPending };
}
